import ActionTypeContrato from "../ActionTypeContrato";

export default class GuardarContrato extends ActionTypeContrato {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = true;
        // nuevoEstado.flag.sensorDeAccionGuardar = !(estado.flag.sensorDeAccionGuardar);
        // nuevoEstado.flag.sensorDeAccionGuardar = this.payload;
        return nuevoEstado;
    }
}
